import * as api from '../../../utils/api/sellers';

export const SELLERS_VIEW_ACTIONS = {
    LOAD_MORE: 'load_more_sellers',
    SET: 'set_sellers_view',
};

export const loadMoreSellers = () => async (dispatch, getState) => {
    const { sellersView } = getState();
    const { sellers, lastItemId } = sellersView;

    const { sellers: moreSellers, hasMorePages, lastItemId: newLastItemId } = await api.fetchSellers(lastItemId);

    const jointSellers = [...sellers, ...moreSellers];

    dispatch(
        setSellersView({
            sellers: jointSellers,
            hasMorePages,
            lastItemId: newLastItemId,
        })
    );
};

export const setSellersView = ({ sellers, hasMorePages, lastItemId }) => ({
    type: SELLERS_VIEW_ACTIONS.SET,
    data: {
        sellers,
        hasMorePages,
        lastItemId,
    },
});
